import ChangeSetDialog from "./ChangeSetDialog";

type CreateChangeSetDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	onSuccess?: () => void;
};

export default function CreateChangeSetDialog({ open, setOpen, onSuccess }: CreateChangeSetDialogProps) {
	return <ChangeSetDialog open={open} setOpen={setOpen} onSuccess={onSuccess} mode="create" />;
}
